import {
	createHook,
	type Action,
	type BoundActions,
	type GetState,
	type HookFunction,
	type SetState,
} from 'react-sweet-state';

import { Store } from '../main';

export const useSite: HookFunction<
	{
		cloudId: string;
	},
	BoundActions<
		{
			cloudId: string;
		},
		{
			setCloudId: (cloudId: string) => ({
				setState,
			}: {
				setState: SetState<{
					cloudId: string;
				}>;
				getState: GetState<{
					cloudId: string;
				}>;
				dispatch: <
					T extends Action<
						{
							cloudId: string;
						},
						any,
						any
					>,
				>(
					actionThunk: T,
				) => ReturnType<T>;
			}) => void;
		}
	>,
	void
> = createHook(Store);
export const useCloudId = (): string => useSite()[0].cloudId;
